import { Link } from 'react-router-dom';

import '../../styles/reset.css';
import '../../styles/root.css';
import '../../styles/global.css';
import '../../styles/main.css';

const Footer = () => {
  const handleClick = (e: { preventDefault: () => void }, target: string) => {
    if (location.pathname === target) {
      e.preventDefault();
      window.location.reload();
    }
  };

  return (
    <footer id="footer">
      <div className="sitemap-bg">
        <div className="m-auto">
          <div className="sitemap-item">
            <div>
              <p>개발 플랫폼</p>
              <ul>
                <li>
                  <Link to="/uxbooster" onClick={(e) => handleClick(e, '/uxbooster')}>
                    <span>UXBooster</span>
                  </Link>
                </li>
                <li>
                  <Link to="/uxboard" onClick={(e) => handleClick(e, '/uxboard')}>
                    <span>UXBoard</span>
                  </Link>
                </li>
                <li>
                  <Link to="/uxcreator" onClick={(e) => handleClick(e, '/uxcreator')}>
                    <span>UXCreator</span>
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <p>서비스</p>
              <ul>
                <li>
                  <Link to="/aichanger" onClick={(e) => handleClick(e, '/aichanger')}>
                    <span>
                      웹 전환 서비스
                      <br />
                      (AIChanger)
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/si" onClick={(e) => handleClick(e, '/si')}>
                    <span>SI 서비스 및 컨설팅</span>
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <p>ESG 솔루션</p>
              <ul>
                <li>
                  <Link to="/gems" onClick={(e) => handleClick(e, '/gems')}>
                    <span>
                      온실가스 관리 솔루션
                      <br />
                      (GEMS)
                    </span>
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <p>구매/입찰 솔루션</p>
              <ul>
                <li>
                  <Link to="/epro" onClick={(e) => handleClick(e, '/epro')}>
                    <span>
                      전자구매 솔루션
                      <br />
                      (ePro)
                    </span>
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <p>고객지원</p>
              <ul>
                <li>
                  <Link to="/notice" onClick={(e) => handleClick(e, '/notice')}>
                    <span>공지사항</span>
                  </Link>
                </li>
                <li>
                  <Link to="/document" onClick={(e) => handleClick(e, '/document')}>
                    <span>자료실</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/technical-support"
                    onClick={(e) => handleClick(e, '/technical-support')}
                  >
                    <span>기술지원</span>
                  </Link>
                </li>
                <li>
                  <Link to="/contact" onClick={(e) => handleClick(e, '/contact')}>
                    <span>문의하기</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://939.co.kr/take"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => handleClick(e, 'https://939.co.kr/take')}
                  >
                    <span>원격지원</span>
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <p>회사소개</p>
              <ul>
                <li>
                  <Link to="/intro" onClick={(e) => handleClick(e, '/intro')}>
                    <span>회사개요</span>
                  </Link>
                </li>
                <li>
                  <Link to="/ci" onClick={(e) => handleClick(e, '/ci')}>
                    <span>CI</span>
                  </Link>
                </li>
                <li>
                  <Link to="/license" onClick={(e) => handleClick(e, '/license')}>
                    <span>특허 및 인증</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="m-auto">
        <div className="info">
          <Link to="/privacy" onClick={(e) => handleClick(e, '/privacy')}>
            <span>개인정보처리방침</span>
          </Link>
          <div className="info-item">
            <ul>
              <li>(주)테이크</li>
              <li>대표이사 : 천우성</li>
              <li>사업자등록번호 : 465-87-00853</li>
            </ul>
            <ul>
              <li>
                (08380) 서울특별시 구로구 디지털로33길 11, 1201호 (구로동, 에이스테크노타워 8차)
              </li>
            </ul>
            <ul>
              <li>대표번호 : 02-855-0801</li>
              <li>FAX : 02-855-0802</li>
              <li>이메일 : tgkim@take-it.co.kr</li>
            </ul>
          </div>
          <p className="copyright">COPYRIGHTⓒ TAKE CORP. ALL RIGHTS RESERVED</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
